export function dateToString (dateStr, fmt) {
  if (dateStr === null || dateStr === undefined || dateStr === '') {
    return dateStr
  }
  const date = new Date(Date.parse(dateStr.split('.')[0].replace(/-/g, '/').replace(/T/g, ' ')))
  if (fmt === null) {
    fmt = 'yyyy-m-dd'
  }
  // const monthArr = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SPT', 'OCT', 'NOV', 'DEC']
  const monthArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': monthArr[date.getMonth()],
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

export function price (priceStr) {
  if (priceStr === null || priceStr === undefined || priceStr === '') {
    return priceStr
  }
  return Number.parseFloat(priceStr).toFixed(2)
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}



// WEBPACK FOOTER //
// ./src/components/filters/index.js